/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */

import { getCollectionReference } from 'services'
import { collectionNames, chainTypes } from 'constant'

export const getDuplicateNFTs = async ({ orderRef, order, chain }: any) => {
  try {
    console.log('inside getDuplicateNFTs')
    let duplicateCollections: any = []
    const collections: any = []

    console.log('topCollectionsRef: any = await getCollectionReference')
    /** Create a ref collection of top collection */
    const topCollectionsRef: any = await getCollectionReference(collectionNames.TOP_COLLECTIONS)
      .where('chain', '==', chain)
      .where('active', '==', true)
      .orderBy(orderRef, order)
      .get()

    console.log('await topCollectionsRef .where(chain, ==, chain)')
    /** Get top collection ordered by market cap **/
    /* topCollectionsRef = await topCollectionsRef
      .where('chain', '==', chain)
      .where('active', '==', true)
      .orderBy(orderRef, order)

    console.log('snapshotDocument  await topCollectionsRef.get()')
    const snapshotDocument = await topCollectionsRef.get()*/

    // console.log('snapshotDocument.docs.map')
    topCollectionsRef.docs.map((document: any) => {
      collections.push({ ...document.data(), id: document.id })
    })
    console.log('snapshotDocument.docs.map complete')

    // If Ethereum collection,
    // Check active collections that have duplicate:
    // name, slug, contract_address, image_url?
    if (chain === chainTypes.ETHEREUM) {
      // Check if two collections have the same slug
      const duplicateSlugs = collections
        .map((col: any) => col.slug)
        .filter((slug: any, i: any, obj: any) => obj.indexOf(slug) != i)
      console.log('duplicateSlugs complete')

      const duplicateNames = collections
        .map((col: any) => col.name)
        .filter((name: any, i: any, obj: any) => obj.indexOf(name) != i)

      console.log('duplicateNames complete')

      /* const duplicateContractAddresses = collections
        .map((col: any) => col.contract_address)
        .filter((contract_address: any, i: any, obj: any) => obj.indexOf(contract_address) != i)*/

      /* const duplicateImageUrls = collections
        .map((col: any) => col.image_url)
        .filter((image_url: any, i: any, obj: any) => obj.indexOf(image_url) != i)*/

      duplicateCollections = collections
        .filter(
          (obj: any) => duplicateSlugs.includes(obj.slug) || duplicateNames.includes(obj.name),
        )
        .map((obj: any) => {
          return {
            ...obj,
            opensea_link: `https://opensea.io/collection/${obj.slug}`,
            magic_eden_link: obj.magic_eden_slug
              ? `https://magiceden.io/marketplace/${obj.magic_eden_slug}`
              : null,
          }
        })
      console.log('duplicateCollections mapped complete')
    } else {
      const duplicateMES = collections
        .map((col: any) => col.magic_eden_slug)
        .filter((slug: any, i: any, obj: any) => obj.indexOf(slug) !== i && i)

      const duplicateSlugs = collections
        .map((col: any) => col.slug)
        .filter((slug: any, i: any, obj: any) => obj.indexOf(slug) != i)

      const duplicateNames = collections
        .map((col: any) => col.name)
        .filter((name: any, i: any, obj: any) => obj.indexOf(name) != i)

      duplicateCollections = collections
        .filter(
          (obj: any) =>
            duplicateMES.includes(obj.magic_eden_slug) ||
            duplicateSlugs.includes(obj.slug) ||
            duplicateNames.includes(obj.name),
        )
        .map((obj: any) => {
          return {
            ...obj,
            opensea_link: `https://opensea.io/collection/${obj.slug}`,
            magic_eden_link: obj.magic_eden_slug
              ? `https://magiceden.io/marketplace/${obj.magic_eden_slug}`
              : null,
          }
        })
    }

    const sortedDuplicates = duplicateCollections.sort((a: any, b: any) =>
      a?.name.localeCompare(b?.name),
    )
    console.log('sortedDuplicates sort complete')

    return {
      success: true,
      data: sortedDuplicates,
    }
  } catch (error) {
    console.log('getDuplicateNFTs error', error)
    return { success: false, error }
  }

  // try {
  //     const duplicatesIds: any = [];
  //     const duplicateCollections: any = [];

  //     /** Get top collection ordered by market cap **/
  //     const { size }: any = await getCollectionReference(collectionNames.TOP_COLLECTIONS)
  //         .where('chain', '==', chain)
  //         .where('active', '==', true)
  //         .get();

  //     const total = size;

  //     /** Create a ref collection of top collection */
  //     let topCollectionsRef: any = await getCollectionReference(collectionNames.TOP_COLLECTIONS);

  //     /** Get top collection ordered by market cap **/
  //     topCollectionsRef = await topCollectionsRef
  //         .limit(100)
  //         .where('chain', '==', chain)
  //         .where('active', '==', true)
  //         .orderBy(orderRef, order);

  //     if (startAfter) {
  //         topCollectionsRef = await topCollectionsRef.startAfter(startAfter);
  //     }

  //     const snapshotDocument = await topCollectionsRef.get()

  //     await Promise.all(
  //         snapshotDocument.docs.map(async (doc: any) => {
  //             const docData = doc.data();

  //             if (chain === chainTypes.ETHEREUM) {
  //                 const document = await getCollectionReference(
  //                     collectionNames.TOP_COLLECTIONS
  //                 )
  //                     .where('chain', '==', chain)
  //                     .where('active', '==', true)
  //                     .where('slug', '==', docData.slug)
  //                     .get();

  //                 if (document.size > 1) {
  //                     document.docs.map(result => {
  //                         const id = result.id;
  //                         if (duplicatesIds.includes(id) === false) {
  //                             const data = result.data()
  //                             duplicatesIds.push(id)
  //                             duplicateCollections.push({
  //                                 ...data,
  //                                 opensea_link: `https://opensea.io/collection/${data.slug}`,
  //                                 magic_eden_link: data.magic_eden_slug
  //                                     ? `https://magiceden.io/marketplace/${data.magic_eden_slug}`
  //                                     : null
  //                             })
  //                         }
  //                     })
  //                 }
  //             } else {
  //                 const document = await getCollectionReference(
  //                     collectionNames.TOP_COLLECTIONS
  //                 )
  //                     .where('chain', '==', chain)
  //                     .where('active', '==', true)
  //                     .where('magic_eden_slug', '==', docData.magic_eden_slug)
  //                     .get();

  //                 if (document.size > 1) {
  //                     document.docs.map(result => {
  //                         const id = result.id;
  //                         if (duplicatesIds.includes(id) === false) {
  //                             const data = result.data()
  //                             duplicatesIds.push(id)
  //                             duplicateCollections.push({
  //                                 ...data,
  //                                 opensea_link: `https://opensea.io/collection/${data.slug}`,
  //                                 magic_eden_link: data.magic_eden_slug
  //                                     ? `https://magiceden.io/marketplace/${data.magic_eden_slug}`
  //                                     : null
  //                             })
  //                         }
  //                     })
  //                 }
  //             }
  //         })
  //     );

  //     const newLimit = limit + 100 >= total ? total : limit + 100

  //     const newStartAfter = snapshotDocument.size > 0
  //         ? snapshotDocument.docs[snapshotDocument.size - 1].data().stats.market_cap
  //         : null;

  //     return {
  //         success: true,
  //         data: duplicateCollections,
  //         limit: newLimit,
  //         startAfter: newStartAfter,
  //         total
  //     }
  // } catch (error) {
  //     console.log('getDuplicateNFTs error', error);
  //     return { success: false, error }
  // }
}

export const changeDuplicateNFtsVisibility = async (collectionId: any) => {
  // eslint-disable-next-line no-async-promise-executor
  try {
    const document = await getCollectionReference(collectionNames.TOP_COLLECTIONS)
      .where('id', '==', collectionId)
      .get()

    if (document.size === 0) {
      return { success: false }
    }

    const data = document.docs[0].data()

    const params = {
      ...data,
      active: data.active ? false : true,
    }

    await getCollectionReference(collectionNames.TOP_COLLECTIONS).doc(collectionId).update(params)

    return { success: true, data: { params, id: collectionId } }
  } catch (error) {
    console.log('changeDuplicateNFtsVisibility | error', error)
    return { success: false, error }
  }
}
